// @flow
import * as yup from "yup";

// eslint-disable-next-line no-unused-vars
import schemaErrorMessages from "../../../utils/schemaErrorMessages";

const getReportSchema: Object = yup.object().shape({
  category: yup.object().shape({
    id: yup.string().required(),
    name: yup.string().required(),
  }),
  description: yup.string().nullable(),
  estimation: yup
    .object()
    .shape({
      until: yup.date().nullable(),
      until_days: yup.number().nullable(),
      reason: yup.string().nullable(),
    })
    .nullable(),
  is_private: yup.boolean().required(),
  kelurahan: yup
    .object()
    .shape({
      id: yup.string().required(),
      name: yup.string().required(),
    })
    .nullable(),
  location: yup
    .object()
    .shape({
      latitude: yup.number(),
      longitude: yup.number(),
    })
    .nullable(),
  media: yup
    .array()
    .of(
      yup.object().shape({
        order: yup.number().nullable(),
        image_url: yup.string().nullable(),
        media_url: yup.string().nullable(),
        type: yup.string().nullable(),
      })
    )
    .nullable(),
  reported_at: yup.date().required(),
  source: yup.object().shape({
    id: yup.string().required(),
    name: yup.string().required(),
  }),
  status_histories: yup
    .array()
    .of(
      yup.object().shape({
        media: yup
          .object()
          .shape({
            order: yup.number().nullable(),
            image_url: yup.string().nullable(),
            media_url: yup.string().nullable(),
            type: yup.string().nullable(),
          })
          .nullable(),
        notes: yup.string().nullable(),
        skpd: yup.object().shape({
          id: yup.string().nullable(),
          name: yup.string().nullable(),
        }),
        status: yup.object().shape({
          id: yup.string().required(),
          name: yup.string().required(),
          color: yup.string().required(),
        }),
        status_at: yup.date().required(),
      })
    )
    .nullable(),
  trace_no: yup.string().required(),
});

export default getReportSchema;
